<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="900">
    <template v-slot:title>{{ editorTitle }}</template>
    <v-row
      ><v-col
        ><v-text-field
          v-model="name"
          label="Name"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field></v-col
    ></v-row>
    <v-row
      ><v-col
        ><v-text-field
          v-model="description"
          label="Description"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field></v-col
    ></v-row>
    <v-row>
      <v-col>
        <v-textarea
        
        <vue-editor v-model="content" label="Default Content"></vue-editor>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-checkbox label="Confirm Email" v-model="forConfirm" hide-details />
      </v-col>
      <v-col>
        <v-checkbox
          label="Amendment Email"
          v-model="forAmendment"
          hide-details
        />
      </v-col>
      <v-col>
        <v-checkbox label="Cancel Email" v-model="forCancel" hide-details />
      </v-col>
      <v-col>
        <v-checkbox
          label="Client Email"
          v-model="forContactClient"
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        ><v-checkbox label="For Web" v-model="forWeb" hide-details
      /></v-col>
      <v-col
        ><v-checkbox label="For Quotation" v-model="forQuotation" hide-details
      /></v-col>
      <v-col
        ><v-checkbox
          label="For Confirmation"
          v-model="forConfirmation"
          hide-details
      /></v-col>
      <v-col
        ><v-checkbox label="For Voucher" v-model="forVoucher" hide-details
      /></v-col>
    </v-row>
    <v-row>
      <v-col
        ><v-checkbox label="For Other" v-model="forOther" hide-details /></v-col
    ></v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <v-row v-if="debug">
      <v-col
        ><code>{{ value }}</code></v-col
      >
    </v-row>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
import { VueEditor } from "vue2-editor";

export default {
  name: "supplier-iti-note-type-edit-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: { BasicDialog, VueEditor },

  data() {
    return {
      debug: false,
      name: this.value ? this.value.name : "Supplier Itinerary Note Type",
      description: this.value
        ? this.value.description
        : "New Supplier Itinerary Note Type Description",
      content: this.value
        ? this.value.description
        : "New Supplier Itinerary Note Type Default Content",
      forConfirm: this.value ? this.value.forConfirm : false,
      forConfirmation: this.value ? this.value.forConfirmation : false,
      forAmendment: this.value ? this.value.forAmendment : false,
      forContactClient: this.value ? this.value.forContactClient : false,
      forCancel: this.value ? this.value.forCancel : false,
      forQuotation: this.value ? this.value.forQuotation : false,
      forVoucher: this.value ? this.value.forVoucher : false,
      forOther: this.value ? this.value.forOther : false,
      forWeb: this.value ? this.value.forWeb : false,
    };
  },

  computed: {
    editorTitle() {
      return `${this.value && this.value.id ? "Edit" : "Add"} - ${this.name}`;
    },
    isValid() {
      return this.name && this.name != "";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newVal) {
      this.name = newVal ? newVal.name : "Supplier Itinerary Note Type";
      this.description = newVal
        ? newVal.description
        : "New Supplier Itinerary Note Type Description";
      this.content = newVal
        ? newVal.content
        : "New Supplier Itinerary Note Type Default Content";
      this.forConfirm = newVal ? newVal.forConfirm : false;
      this.forConfirmation = newVal ? newVal.forConfirmation : false;
      this.forAmendment = newVal ? newVal.forAmendment : false;
      this.forContactClient = newVal ? newVal.forContactClient : false;
      this.forCancel = newVal ? newVal.forCancel : false;
      this.forQuotation = newVal ? newVal.forQuotation : false;
      this.forVoucher = newVal ? newVal.forVoucher : false;
      this.forOther = newVal ? newVal.forOther : false;
      this.forWeb = newVal ? newVal.forWeb : false;
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        id: this.value && this.value.id ? this.value.id : undefined,
        name: this.name,
        description: this.description,
        content: this.content,
        forConfirm: this.forConfirm,
        forConfirmation: this.forConfirmation,
        forAmendment: this.forAmendment,
        forContactClient: this.forContactClient,
        forCancel: this.forCancel,
        forQuotation: this.forQuotation,
        forVoucher: this.forVoucher,
        forOther: this.forOther,
        forWeb: this.forWeb,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/supplier-itinerary-note-types/SupplierItiNoteTypeEditDialog.vue